

function ApiBanner (){

    return(<>
        <div className="apiBanner">
            <p>Get started with our API.</p>
            <p> Check out our <a href="https://test-dpp.mynext.id/docs/dpp_api/add-manufacturer" target="_blank">developer documentation</a> to learn more.</p>
        </div>
    </>)
}


export default ApiBanner;